import React from 'react';
import styled from 'styled-components';
import {IconButton} from '@mui/material';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import {NumberInput} from './NumberInput';

const Label = styled.span`
  font-size: 16px;
`;

const PdfPaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: auto;
`;

const LockedIcon = styled.span`
  color: green;
  font-size: 20px;
`;

export function PdfPagination({
  count,
  page,
  onChange,
  onRegenerateClick,
  locked,
}: {
  count: number;
  page: number;
  onChange: (pageNo: number) => void;
  onRegenerateClick: () => void;
  locked?: boolean;
}) {
  return (
    <PdfPaginationContainer>
      <Label>ପୃଷ୍ଠା</Label>
      <NumberInput value={page} onChange={onChange} min={1} max={count} />
      <Label>ସମୁଦାୟ {count}</Label>
      {locked && (
        <LockedIcon
          role="img"
          aria-label="Verified and Locked"
          title="Verified & Locked"
        >
          ✅
        </LockedIcon>
      )}
      <IconButton
        size="small"
        aria-label="Regenerate text"
        onClick={onRegenerateClick}
        disabled={locked}
      >
        <AutoModeIcon fontSize="small" />
      </IconButton>
    </PdfPaginationContainer>
  );
}
